module.exports = "<div>\n        \n<router-outlet></router-outlet>\n</div>\n\n"